import 'reflect-metadata';
import { Expose, plainToInstance, instanceToPlain } from 'class-transformer';

export class UserSearch {
  @Expose({ name: 'first_name' })
  firstName: string;

  @Expose({ name: 'last_name' })
  lastName?: string;

  username: string;

  email?: string;

  avatar?: string;

  constructor(
    firstName: string,
    lastName: string | undefined,
    username: string,
    email: string | undefined,
    avatar: string | undefined
  ) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.username = username;
    this.email = email;
    this.avatar = avatar;
  }

  static fromJson(json: Record<string, any>): UserSearch {
    return plainToInstance(UserSearch, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
